import { TableProps } from "antd";
import AntTable from "../components/CommonTable";
import dayjs from "dayjs";
import tableStyle from "../style/tableCol.module.scss";
import { ConvertFirstLetter } from "../utils/ConvertFirstLetter";
import { Data, BookingData } from "../utils/const/bookingConst";
import { ReactComponent as OpenLink } from "../assests/nav/open_link.svg";
import { changeTextColor } from "../utils/changeTextColor";
import formatName from "../utils/formatName";
const BookingTable = ({
  data,
  setShowDrawer,
  setSelectedData,
  isDropOff,
  isPickup,
}: {
  data: BookingData[];
  setShowDrawer: any;
  setSelectedData: any;
  isDropOff?: boolean;
  isPickup?: boolean;
}) => {
  const columns: TableProps<Data>["columns"] = [
    {
      title: "Booking Id",
      dataIndex: "_id",
      key: "_id",
      width: 250,
      render: (_, record) => (
        <div
          className={tableStyle["wrap-img-name"]}
          style={{
            justifyContent: "flex-start",
            cursor: "pointer",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          onClick={() => {
            setShowDrawer(true);
            setSelectedData(record);
          }}
        >
          <p
            className={tableStyle["name"]}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              margin: 0,
              flex: 1,
              minWidth: 0,
            }}
          >
            {record._id ? record._id : "--"}
          </p>
          <OpenLink style={{ flexShrink: 0, marginLeft: "6px" }} />
        </div>
      ),
    },
    {
      title: "Bike Name",
      dataIndex: ["bikeId", "name"],
      key: "name",
      width: 150,
      render: (bikeName: string) => <p>{bikeName ? bikeName : "--"}</p>,
    },

    {
      title: "Mobile No",
      dataIndex: ["userId", "mobile"],
      key: "mobile",
      width: 150,
      render: (mobile: string) => <p>{mobile ? mobile : "--"}</p>,
    },
    {
      title: "Rider Name",
      dataIndex: ["userId", "firstName"],
      key: "firstName",
      width: 150,
      render: (firstName: string) => (
        <p>{firstName ? formatName(firstName) : "--"}</p>
      ),
    },
    {
      title: "Booking Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (name: string) => (
        <p
          style={{
            color: changeTextColor(name),
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          {(name || "").toUpperCase()}
        </p>
      ),
    },
    {
      title: "Station Name",
      dataIndex: ["stationId", "name"],
      key: "name",
      width: 200,
      render: (name: string) => <p>{ConvertFirstLetter(name)}</p>,
    },
    {
      title: "Pickup Date",
      dataIndex: "from",
      key: "from",
      width: 200,
      render: (text: any) => <p>{dayjs(text).format("DD MMM YYYY, hA")}</p>,
    },
    {
      title: "Drop Date",
      dataIndex: "to",
      key: "to",
      width: 200,
      render: (text: any) => <p>{dayjs(text).format("DD MMM YYYY, hA")}</p>,
    },
  ];
  if (isDropOff || isPickup) {
    columns.splice(3, 0, {
      title: "Ride Status",
      dataIndex: "rideStatus",
      key: "rideStatus",
      width: 150,
      render: (name: string) => (
        <p
          style={{
            color: changeTextColor(name),
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          {(name || "").toUpperCase()}
        </p>
      ),
    });
  }
  if (isDropOff) {
    columns.splice(5, 1);
  }
  if (isPickup) {
    columns.splice(6, 1);
  }
  return <AntTable columns={columns} data={data} scrollWidth={1600} />;
};

export default BookingTable;
